import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable, shareReplay } from "rxjs"
import { environment } from "src/environments/environment"
import { EmployeeIncludedName, EmployeeMbrad } from "../models"

@Injectable({
    providedIn: "root",
})
export class EmployeeService {
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.employee

    constructor(private _http: HttpClient) {}

    GetEmployeesNames(included: string[], excluded: string[]): Observable<EmployeeIncludedName[]> {
        return this._http.get<EmployeeIncludedName[]>(this._apiUrl + "/names", {
            params: {
                included: included.join(","),
                excluded: excluded.join(","),
            }
        })
    }

    private _employees$ = this._fetchEmployees();

    private _fetchEmployees(): Observable<EmployeeMbrad[]> {
        return this._http
            .get<EmployeeMbrad[]>(`${this._apiUrl}/employees`)
            .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }

    get employees$() {
        return this._employees$;
    }

    GetEmployeeManager(employeeId: string): Observable<string> {
        return this._http.get<string>(`${this._apiUrl}/manager/${employeeId}`)
    }
}
